import { render, staticRenderFns } from "./create-sales-order-dialog.vue?vue&type=template&id=9570fd3e&scoped=true&"
import script from "./create-sales-order-dialog.vue?vue&type=script&lang=js&"
export * from "./create-sales-order-dialog.vue?vue&type=script&lang=js&"
import style0 from "./create-sales-order-dialog.vue?vue&type=style&index=0&id=9570fd3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9570fd3e",
  null
  
)

export default component.exports